import React from 'react';
import { Route, Routes } from 'react-router-dom';

import AppNavigate from '../../components/reusable/app-navigate/AppNavigate';
import { Paths } from '../../shared/paths';
import Exercises from './exercises/Exercises';
import NewExercise from './new-exercise/NewExercise';
import ViewExercise from './view-exercise/ViewExercise';

export default function ExercisesRouter() {
  return (
    <Routes>
      <Route path={`${Paths.exercises.list}/*`} element={<Exercises />} />
      <Route path={`${Paths.exercises.new}`} element={<NewExercise />} />
      <Route
        path={`/:exerciseId${Paths.exercises.edit}`}
        element={<NewExercise />}
      />
      <Route
        path={`/:exerciseId${Paths.exercises.view}/*`}
        element={<ViewExercise />}
      />
      <Route
        path={`/:exerciseId/*`}
        element={<AppNavigate to={Paths.exercises.toList} replace />}
      />
      <Route
        path={'*'}
        element={<AppNavigate to={Paths.exercises.toList} replace />}
      />
    </Routes>
  );
}
